module.exports = __webpack_public_path__ + "img/specif_srb.3ac0f91b.jpg";